import { normalQueryTypes } from '@ow/utils'

export const filterSpec = {
  // 文本类型支持等于，不等于，包含、不包含、为空、不为空查询
  queryTypes: [
    // 'equal',
    // 'notEqual',
    'containString',
    'notContainString',
    'isNull',
    'notNull',
  ].map((p) => normalQueryTypes[p]),
}

export const config = {
  // icon: faEdit,
  slug: '',
  title: '文本',
  type: 'text',
  intro: '支持单行、多行文本，可设置多个文本框。', // 类似鼠标移过的tooltip
  required: false,
  description: '字段描述',
  readonly: false,
  // hiddenWhenCreate: false,
  hidden: false,
  render: 'input', // input
  // toogle: { type: 'number', icon: faCalculator, title: '数值' },
  rangeSetting: true, // 是否限制字数，为true maxLen,minLen起效
  minlen: 1,
  maxlen: 500,
  defaultValue: '',
}
